import { HTMLAttributes } from "react"
import { cn } from "lib/utils"

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-ip-gray-5/20", className)}
      {...props}
    />
  )
}

export { Skeleton }
